module.exports = __webpack_public_path__ + "thavAtmosphäre.jpg?f4ce4ea29f770b38dffcfb7e30364e54";


//////////////////
// WEBPACK FOOTER
// ./src/assets/thavAtmosphäre.jpg
// module id = 16
// module chunks = 0